"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

require("core-js/modules/es.array.flat.js");

require("core-js/modules/es.array.unscopables.flat.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagName = exports.createDeserializer = exports.deserializeHtml = exports.deserializeElement = void 0;

var slate_hyperscript_1 = require("slate-hyperscript");

var wrapTopLevelInlineNodesInParagraphs_1 = __importDefault(require("./wrapTopLevelInlineNodesInParagraphs"));

var TagName;

(function (TagName) {
  TagName["Element"] = "element";
  TagName["Text"] = "text";
  TagName["Fragment"] = "fragment";
})(TagName || (TagName = {}));

exports.TagName = TagName;
var NODE_TEXT_NODE = 3;
var NODE_ELEMENT_NODE = 1;
var DEFAULT_ELEMENTS = ['P', 'BR']; // @ts-ignore todo: resolve types

var deserializeElement = function deserializeElement(_a) {
  var element = _a.element,
      deserializers = _a.deserializers;
  if (element.nodeType === NODE_TEXT_NODE) return element.textContent;
  if (element.nodeType !== NODE_ELEMENT_NODE) return [];
  var children = Array.from(element.childNodes).map(function (element$) {
    return deserializeElement({
      element: element$,
      deserializers: deserializers
    });
  }).flat();

  if (element.nodeName === 'BODY') {
    return slate_hyperscript_1.jsx(TagName.Fragment, {}, children);
  }

  var elementDeserializer = deserializers.find(function (deserializer$) {
    return deserializer$.tagName === TagName.Element && deserializer$.match(element);
  });

  if (elementDeserializer) {
    var attrs = elementDeserializer.map(element);
    return slate_hyperscript_1.jsx(TagName.Element, attrs, children);
  }

  var textDeserializer = deserializers.find(function (deserializer$) {
    return deserializer$.tagName === TagName.Text && deserializer$.match(element);
  });

  if (textDeserializer) {
    return children.map(function (child) {
      return slate_hyperscript_1.jsx(TagName.Text, textDeserializer.map(element), child);
    });
  }

  if (DEFAULT_ELEMENTS.includes(element.nodeName)) {
    return slate_hyperscript_1.jsx(TagName.Element, {
      type: 'paragraph'
    }, children);
  }

  return children;
};

exports.deserializeElement = deserializeElement;

var deserializeHtml = function deserializeHtml(html, deserializers, domParser) {
  var domParser$ = domParser || new DOMParser();
  var parsed = domParser$.parseFromString(html, 'text/html');
  var result = deserializeElement({
    element: parsed.body,
    deserializers: Object.values(deserializers)
  });
  var result$ = wrapTopLevelInlineNodesInParagraphs_1.default(result);
  return result$;
};

exports.deserializeHtml = deserializeHtml;

var createDeserializer = function createDeserializer(_a) {
  var nodeName = _a.nodeName,
      tagName = _a.tagName;
  return {
    match: function match(element) {
      return element.nodeName === nodeName;
    },
    map: function map() {
      return {
        type: nodeName
      };
    },
    tagName: tagName
  };
};

exports.createDeserializer = createDeserializer;